import type { TaskStatus } from "../../types";

/** Columns of the task board, in workflow order. */
export const TASK_STATUSES: TaskStatus[] = ["todo", "doing", "blocked", "done"];
